import { render, staticRenderFns } from "./GroupMemberAddDialog.vue?vue&type=template&id=2ec5f424&"
import script from "./GroupMemberAddDialog.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberAddDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports